// extracted by mini-css-extract-plugin
export default {"errorPadding":"style_errorPadding__TAYyb"};